@if (!shift) {
  <div class="mt-3 p-3 border border-light rounded-3">
    <span class="fw-normal text-dark"
      ><small
        >{{ 'page.shifts.staff' | translate }}
        <fa-icon
          [icon]="faInfoCircle"
          class="text-secondary ms-2"
        ></fa-icon></small
    ></span>
    <p class="text-secondary py-5">
      {{ 'page.shifts.staff_text' | translate }}
    </p>
  </div>
}

@if (shift && !shift.userId) {
  <div>
    <wilson-shift-assigned-user-identity></wilson-shift-assigned-user-identity>
    <div class="d-flex mt-2">
      <div class="fw-normal text-light ms-1">0.0</div>
      <div class="progress bg-light ms-2 mt-2">
        <div class="progress-bar" role="progressbar" style="width: 0%"></div>
      </div>
    </div>
    <div class="text-light score-lable">
      <span class="fw-normal">{{ 'shift.assignment.smart' | translate }}</span
      ><span>{{ 'shift.assignment.score' | translate }}</span>
    </div>
    @if (hasPreferencePermission) {
      <div>
        <div class="d-flex mt-1">
          <div class="fw-normal text-light ms-1">0.0</div>
          <div class="progress bg-light ms-2 mt-2">
            <div
              class="progress-bar"
              role="progressbar"
              style="width: 0%"
            ></div>
          </div>
        </div>
        <div class="text-light score-lable">
          <span class="fw-normal">{{
            'shift.assignment.pref' | translate
          }}</span
          ><span>{{ 'shift.assignment.score' | translate }}</span>
        </div>
      </div>
    }
    <div class="mt-4">
      <ng-container *ngTemplateOutlet="staffSearchButtons"></ng-container>
    </div>
  </div>
}

@if (shift && shift.userId) {
  <div>
    <wilson-shift-assigned-user-identity [user]="shift.user">
      <wilson-shift-last-seen [payload]="shift"></wilson-shift-last-seen>
      <wilson-shift-confirmed-declined
        [payload]="shift"
      ></wilson-shift-confirmed-declined>
    </wilson-shift-assigned-user-identity>
    <div class="d-flex mt-2">
      <div class="fw-normal text-dark ms-1">{{ smartScore }}</div>
      <div class="progress bg-secondary ms-3 mt-2">
        <div
          class="progress-bar"
          role="progressbar"
          [style]="smartScoreProgress"
        ></div>
      </div>
    </div>
    <div class="text-secondary score-lable">
      <span class="fw-normal ps-2">{{
        'shift.assignment.smart' | translate
      }}</span
      ><span>{{ 'shift.assignment.score' | translate }}</span>
    </div>
    @if (hasPreferencePermission) {
      <div>
        <div class="d-flex mt-1">
          <div class="fw-normal text-dark ms-1">{{ prefScore }}</div>
          <div class="progress bg-secondary ms-3 mt-2">
            <div
              class="progress-bar"
              role="progressbar"
              [style]="prefScoreProgress"
            ></div>
          </div>
        </div>
        <div class="text-secondary score-lable">
          <span class="fw-normal ps-2">{{
            'shift.assignment.pref' | translate
          }}</span
          ><span>{{ 'shift.assignment.score' | translate }}</span>
        </div>
      </div>
    }
    <div class="mt-2">
      <ng-container *ngTemplateOutlet="staffSearchButtons"></ng-container>
    </div>
  </div>
}
@let hasShiftUpdatePermissions =
  can(RoleAction.Update, RolePermissionSubject.Shift);
<ng-template #staffSearchButtons>
  <div class="d-flex justify-content-between mb-2 mx-2">
    <wilson-open-find-staff-button
      style="margin-right: 6px; flex: 3; min-width: 0"
      [shift]="shift"
      [isDisabled]="!canAssignShift()"
      (clicked)="openFindStaffPopup()"
    ></wilson-open-find-staff-button>

    @if (
      !disabled() &&
      !(
        $safeNavigationMigration(shift?.activities) | areAllActivitiesFinished
      ) &&
      !($safeNavigationMigration(shift?.activities) | isOneActivityStarted) &&
      shift.userId
    ) {
      <button
        (click)="unassignStaff()"
        style="flex: 1"
        nz-button
        nzType="default"
        nzDanger
        nz-tooltip
        [nzTooltipTitle]="
          !hasShiftUpdatePermissions
            ? ('general.forbidden_action' | translate)
            : ''
        "
        [disabled]="!hasShiftUpdatePermissions"
      >
        {{ 'general.remove' | translate }}
      </button>
    }
  </div>
</ng-template>
